import React from 'react';
import { Inline, Stack, Text, useDevice, useViewport } from '@treatwell/ui';
import styles from './TreatsConversion.module.css';

export type TreatsConversionProps = {
  earnRateNumerator: { value: string; label: string };
  earnRateDenominator: { value: string; label: string };
};

export const TreatsConversion = ({
  earnRateNumerator,
  earnRateDenominator,
}: TreatsConversionProps) => {
  const { isMobile } = useDevice();
  const isMobileViewport = useViewport({
    device: ['mobile', 'tablet'],
    serverRender: isMobile,
  });

  const textValueType = isMobileViewport ? 'xlHeader' : 'lgHero';
  const textLabelType = isMobileViewport ? 'captionHeavy' : 'lgHeader';

  return (
    <p>
      <Inline as="span" align="center" space={isMobileViewport ? 'md' : 'lg'}>
        <Stack as="span" space="base" align="center">
          <Text className={styles.value} type={textValueType}>
            {earnRateNumerator.value}
          </Text>
          <Text className={styles.label} type={textLabelType}>
            {earnRateNumerator.label}
          </Text>
        </Stack>
        <Text className={styles.sign} type={textValueType}>
          =
        </Text>
        <Stack as="span" space="base" align="center">
          <Text className={styles.value} type={textValueType}>
            {earnRateDenominator.value}
          </Text>
          <Text className={styles.label} type={textLabelType}>
            {earnRateDenominator.label}
          </Text>
        </Stack>
      </Inline>
    </p>
  );
};
